import { render, staticRenderFns } from "./RsaConfigurazioneSpeseExtraListComponent.vue?vue&type=template&id=61cc2ff6"
import script from "./RsaConfigurazioneSpeseExtraListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSpeseExtraListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports